(function () {
    // Remove the no-js class from the <html> element
    document.documentElement.classList.remove('no-js');
    /* Mobile navigation toggle */
    var navToggle = document.querySelector('.js-nav_toggle');
    var nav = document.querySelector('#header');
    navToggle.addEventListener('click', function (e) {
        navToggle.classList.toggle('is-active');
        nav.classList.toggle('c-header--open');
    });


    var slideData = document.querySelectorAll("[data-label]");

    var menuSwiper = new Swiper('.js-menu-swiper',{
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.js-menu-pagination',
                  clickable: true,
              renderBullet: function (index, className) {
                return '<span class="' + className + ' c-btn c-btn--pri ">' + (slideData[index].dataset.label) + '</span>';
              },
          },
    });

    var bannerSwiper = new Swiper('.js-banner-swiper', {
        speed: 350,
        loop: true,
        effect: 'fade',
        autoplay: {
            delay: 3000
        },
        pagination: {
            el: '.js-banner-pagination',
            clickable: true
        }
    });
})();
